<div class="main-container animated fadeInRight depura">

  <!-- ENCABEZADO -->
  <div class="d-flex align-items-center mb-1">
    <i class="fas fa-truck depura-title-icon me-3" aria-hidden="true"></i>
    <h3 class="mb-0 fw-bold">{{ DAT_TITULOS.titulo }}</h3>
  </div>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb bg-transparent px-0 py-1 mb-3">
      <li class="breadcrumb-item"><a href="index.html">Home</a></li>
      <li class="breadcrumb-item">{{ GLOBAL_TITULOS.modulo }}</li>
      <li class="breadcrumb-item active" aria-current="page">{{ DAT_TITULOS.tituloCardList }}</li>
    </ol>
  </nav>

  <!-- BARRA DE HERRAMIENTAS -->
  <div class="card shadow-sm border-0 mb-3">
    <div class="card-body py-2">
      <div class="row g-2 align-items-end">
        <div class="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
          <label class="small fw-bold mb-1" for="filtroEstado">Estado</label>
          <div class="input-group">
            <span class="input-group-text bg-white"><i class="fas fa-clipboard-list text-primary"></i></span>
            <select id="filtroEstado" class="form-select" [(ngModel)]="filtroEstado" (change)="listar()" [disabled]="loading">
              <option *ngFor="let e of estados" [value]="e.value">{{ e.value === '*' ? 'Todos los Estados' : e.value + 's' }}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
          <label class="small fw-bold mb-1" for="filtroFuente">Fuente</label>
          <div class="input-group">
            <span class="input-group-text bg-white"><i class="fas fa-database text-primary"></i></span>
            <select id="filtroFuente" class="form-select" [(ngModel)]="filtroFuente" (change)="aplicarFiltros()">
              <option value="">Todas las fuentes</option>
              <option *ngFor="let f of fuentes" [value]="f">{{ f }}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md mb-2 mb-md-0">
          <div class="input-group">
            <span class="input-group-text bg-white"><i class="fas fa-search text-muted"></i></span>
            <input type="search" class="form-control" placeholder="Buscar por ID, cliente, documento o vendedor"
                   [ngModel]="textoBuscar" (ngModelChange)="onBuscar($event)" aria-label="Buscar registros" />
          </div>
        </div>
        <div class="col-12 col-md-auto mb-0 d-flex justify-content-end">
          <button type="button" class="btn btn-success me-2" (click)="exportar()" [disabled]="exportando || loading">
            <i class="fas" [ngClass]="exportando ? 'fa-spinner fa-spin' : 'fa-download'"></i> Descargar registros
          </button>
          <button type="button" class="btn btn-primary me-2" (click)="abrirCarga()" [disabled]="loading">
            <i class="fas fa-cloud-upload-alt"></i> Carga masiva
          </button>
          <button type="button" class="btn btn-outline-primary" (click)="listar()" [disabled]="loading" title="Actualizar" aria-label="Actualizar">
            <i class="fas fa-sync-alt" [class.fa-spin]="loading"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- CONTADOR + PAGINACION -->
  <div class="d-flex flex-wrap justify-content-between align-items-center mb-2">
    <span class="small text-muted">{{ rangoMostrado }}</span>
    <nav *ngIf="totalPaginas > 1" aria-label="Paginación">
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item" [class.disabled]="pagina === 1">
          <a class="page-link" href="javascript:void(0)" (click)="cambiarPagina(-1)" aria-label="Anterior"><i class="fas fa-chevron-left"></i></a>
        </li>
        <li class="page-item" *ngFor="let p of paginas" [class.active]="p === pagina" [class.disabled]="p === null">
          <a class="page-link" href="javascript:void(0)" (click)="p !== null && irPagina(p)">{{ p === null ? '…' : p }}</a>
        </li>
        <li class="page-item" [class.disabled]="pagina === totalPaginas">
          <a class="page-link" href="javascript:void(0)" (click)="cambiarPagina(1)" aria-label="Siguiente"><i class="fas fa-chevron-right"></i></a>
        </li>
      </ul>
    </nav>
  </div>

  <!-- LOADING SKELETON -->
  <ng-container *ngIf="loading">
    <div class="card depura-card border-0 shadow-sm mb-3" *ngFor="let s of [1,2,3]">
      <div class="card-body">
        <div class="row">
          <div class="col-md-3"><div class="skeleton skeleton-badge"></div><div class="skeleton skeleton-title"></div><div class="skeleton"></div></div>
          <div class="col-md-3"><div class="skeleton"></div><div class="skeleton"></div><div class="skeleton"></div></div>
          <div class="col-md-2"><div class="skeleton"></div><div class="skeleton"></div></div>
          <div class="col-md-2"><div class="skeleton"></div><div class="skeleton"></div><div class="skeleton"></div></div>
          <div class="col-md-2"><div class="skeleton skeleton-btn"></div></div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ERROR -->
  <div *ngIf="!loading && errorCarga" class="alert alert-danger d-flex justify-content-between align-items-center" role="alert">
    <span><i class="fas fa-exclamation-triangle me-2"></i>Ocurrió un error al consultar los registros.</span>
    <button type="button" class="btn btn-sm btn-outline-danger" (click)="listar()">Reintentar</button>
  </div>

  <!-- EMPTY STATE -->
  <div *ngIf="!loading && !errorCarga && !filtrados.length" class="text-center text-muted py-5">
    <i class="fas fa-clipboard-check fa-3x mb-3"></i>
    <h5 *ngIf="!registros.length">{{ filtroEstado === ESTADO_PENDIENTE ? 'No existen incidencias pendientes' : 'No existen registros para el estado seleccionado' }}</h5>
    <h5 *ngIf="registros.length">Ningún registro coincide con el filtro</h5>
    <p class="mb-0" *ngIf="registros.length">Ajuste el término de búsqueda o el filtro de fuente.</p>
  </div>

  <!-- GRILLA DE TARJETAS -->
  <ng-container *ngIf="!loading && !errorCarga">
    <div class="card depura-card border-0 shadow-sm mb-3" *ngFor="let r of paginaActual; trackBy: trackById"
         [ngClass]="esConcluido(r) ? 'depura-card-concluido' : 'depura-card-pendiente'">
      <div class="card-body py-3">
        <div class="row g-0 align-items-center">

          <!-- Identificación -->
          <div class="col-12 col-md-3 depura-col d-flex align-items-start">
            <i class="fas fa-file-invoice fa-2x depura-icon me-3 mt-1" aria-hidden="true"></i>
            <div>
              <span class="badge rounded-pill depura-badge" [ngClass]="esConcluido(r) ? 'depura-badge-ok' : 'depura-badge-warn'">
                <i class="fas" [ngClass]="esConcluido(r) ? 'fa-check-circle' : 'fa-clock'"></i> {{ r.estado }}
              </span>
              <h6 class="mb-0 mt-1 fw-bold">Depuración #{{ r.id }}</h6>
              <div class="small text-muted">DocVentas: <span class="text-dark">{{ r.docVentas }}</span></div>
              <div class="small text-muted"><i class="far fa-calendar-alt me-1"></i>Fecha: {{ r.fechaCreacion | date:'dd/MM/yyyy HH:mm' }}</div>
            </div>
          </div>

          <!-- Cliente / Vendedor / Agencia -->
          <div class="col-12 col-sm-6 col-md-3 depura-col">
            <div class="depura-item">
              <i class="fas fa-user"></i>
              <div>
                <div class="depura-label">Cliente</div>
                <div class="depura-value text-truncate" [title]="r.nombreCli || ''">{{ r.cliente }}<span *ngIf="r.nombreCli"> - {{ r.nombreCli }}</span></div>
              </div>
            </div>
            <div class="depura-item">
              <i class="fas fa-user-tie"></i>
              <div>
                <div class="depura-label">Vendedor</div>
                <!-- <div class="depura-value"></div> -->
                <div class="depura-value text-truncate" *ngIf="r.nombreVend" [title]="r.nombreVend">{{ r.vendedor || '-' }} - {{ r.nombreVend }}</div>
              </div>
            </div>
            <div class="depura-item">
              <i class="fas fa-map-marker-alt"></i>
              <div>
                <div class="depura-label">Agencia</div>
                <div class="depura-value">{{ r.agencia }} - {{ r.nombreAgencia }}</div>
              </div>
            </div>
          </div>

          <!-- Monto / Items -->
          <div class="col-12 col-sm-6 col-md-2 depura-col">
            <div class="depura-item">
              <i class="fas fa-dollar-sign"></i>
              <div>
                <div class="depura-label">Monto</div>
                <div class="depura-value fw-bold">{{ r.monto | currency:'USD':'US$ ':'1.2-2' }}</div>
              </div>
            </div>
            <div class="depura-item">
              <i class="fas fa-box"></i>
              <div>
                <div class="depura-label">Ítems</div>
                <div class="depura-value fw-bold">{{ r.numItems }} {{ r.numItems === 1 ? 'item' : 'items' }}<span *ngIf="r.totalParcial"> - {{ r.totalParcial }}</span></div>
              </div>
            </div>
          </div>

          <!-- Causa / Fuente / Email / Plan -->
          <div class="col-12 col-sm-6 col-md-2 depura-col">
            <div class="depura-item depura-item-sm">
              <i class="fas fa-exclamation-triangle"></i>
              <div><div class="depura-label">Causa</div><div class="depura-value text-truncate" [title]="r.descripCausa || ''">{{ r.descripCausa || '-' }}</div></div>
            </div>
            <!-- <div class="depura-item depura-item-sm">
              <i class="fas fa-database"></i>
              <div><div class="depura-label">Fuente</div><div class="depura-value">{{ r.fuente || '-' }}</div></div>
            </div> -->
            <div class="depura-item depura-item-sm">
              <i class="fas fa-envelope"></i>
              <div>
                <div class="depura-label">Email pendiente</div>
                <div class="depura-value" [title]="r.emailDestino || ''">{{ r.emailEnviado ? 'No' : 'Sí' }}</div>
              </div>
            </div>
            <div class="depura-item depura-item-sm">
              <i class="fas fa-clipboard"></i>
              <div>
                <div class="depura-label">Plan de acción</div>
                <div class="depura-value text-truncate" [title]="r.planAccion || ''">
                  <span *ngIf="r.planAccion">{{ r.planAccion }}</span>
                  <i *ngIf="!r.planAccion" class="text-muted">No ingresado</i>
                </div>
              </div>
            </div>
          </div>

          <!-- Acción -->
          <div class="col-12 col-sm-6 col-md-2 ps-md-3 pt-3 pt-md-0">
            <button *ngIf="!esConcluido(r)" type="button" class="btn btn-warning btn-block fw-bold depura-btn" (click)="abrirPlan(r)">
              <i class="fas fa-edit"></i> {{ r.planAccion ? 'Editar' : '+ Ingresar' }}<br>Plan de Acción
            </button>
            <button *ngIf="esConcluido(r)" type="button" class="btn btn-primary btn-block depura-btn" (click)="abrirPlan(r)">
              <i class="fas fa-eye"></i> Visualizar plan
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- MODAL PLAN DE ACCION -->
<app-lfsa-modal [innTemplate]="modalPlanTemplate" [classModal]="'modal-dialog modal-xl depura-modal'" [idButton]="'abrirModalPlan'"
    [idOpen]="'ModalPlanDepura'" [idClose]="'cerrarModalPlan'" [titulo]="titleModalPlan">
</app-lfsa-modal>

<ng-template #modalPlanTemplate>
  <form [formGroup]="formPlan" (ngSubmit)="guardarPlan()" novalidate *ngIf="seleccionado as s" class="depura-plan">

    <!-- Resumen -->
    <div class="depura-panel mb-3">
      <div class="depura-panel-header">
        <i class="fas fa-info-circle"></i> Resumen de Incidencia
      </div>
      <div class="depura-panel-body row g-0">
        <div class="col-12 col-sm-6 col-lg-2 depura-res-col">
          <div class="depura-item">
            <i class="fas fa-user"></i>
            <div>
              <div class="depura-label">Cliente</div>
              <div class="depura-value fw-bold">{{ s.cliente }}<span *ngIf="s.nombreCli"> - {{ s.nombreCli }}</span></div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-2 depura-res-col">
          <div class="depura-item">
            <i class="fas fa-map-marker-alt"></i>
            <div>
              <div class="depura-label">Agencia</div>
              <div class="depura-value fw-bold">{{ s.agencia }}</div>
              <div class="depura-value fw-bold text-truncate" *ngIf="s.nombreAgencia" [title]="s.nombreAgencia">{{ s.nombreAgencia }}</div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3 depura-res-col">
          <div class="depura-item">
            <i class="fas fa-user-friends"></i>
            <div>
              <div class="depura-label">Vendedor</div>
              <div class="depura-value fw-bold">{{ s.vendedor || '-' }}<span *ngIf="s.nombreVend"> - {{ s.nombreVend }}</span></div>
            </div>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-lg-3 depura-res-col">
          <div class="depura-item">
            <i class="fas fa-exclamation-triangle"></i>
            <div><div class="depura-label">Causa</div><div class="depura-value fw-bold">{{ s.causa }} - {{ s.descripCausa || '-' }}</div></div>
          </div>
        </div>
        <!-- <div class="col-6 col-sm-4 col-lg-2 depura-res-col">
          <div class="depura-item">
            <i class="fas fa-database"></i>
            <div><div class="depura-label">Fuente</div><div class="depura-value fw-bold">{{ s.fuente || '-' }}</div></div>
          </div>
        </div> -->
        <div class="col-12 col-sm-4 col-lg-2 depura-res-col">
          <div class="depura-item">
            <i class="fas fa-dollar-sign"></i>
            <div><div class="depura-label">Monto</div><div class="depura-value fw-bold">{{ s.monto | currency:'USD':'US$ ':'1.2-2' }}</div></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Plan de acción -->
    <div class="depura-panel mb-3">
      <div class="depura-panel-header">
        <i class="fas fa-file-alt"></i>
        <label for="planAccion" class="mb-0">Plan de Acción / Gestión Experiencia al Cliente (Matriz de Consecuencia) *</label>
      </div>
      <div class="depura-panel-body">
        <textarea id="planAccion" class="form-control" rows="4" formControlName="planAccion" [maxlength]="PLAN_MAX"
                  placeholder="Ingrese las acciones tomadas conforme a la matriz de consecuencias..."
                  [class.is-invalid]="formPlan.get('planAccion').touched && formPlan.get('planAccion').invalid"></textarea>
        <div class="invalid-feedback">El plan de acción es obligatorio (mínimo 5 caracteres).</div>
        <div class="d-flex justify-content-between mt-1 depura-hint">
          <span class="fw-bold">{{ (formPlan.get('planAccion').value || '').length }} / {{ PLAN_MAX }} caracteres</span>
          <span>Registre las acciones realizadas y el seguimiento correspondiente.</span>
        </div>
      </div>
    </div>

    <!-- Estado -->
    <div class="depura-panel mb-3">
      <div class="depura-panel-header">
        <i class="fas fa-cog"></i> Estado de la gestión
      </div>
      <div class="depura-panel-body">
        <div class="btn-group depura-estado" role="group" aria-label="Estado de la gestión">
          <input type="radio" class="btn-check" id="estadoPendiente" formControlName="estado" [value]="ESTADO_PENDIENTE" autocomplete="off">
          <label class="btn depura-estado-opt" for="estadoPendiente">
            <i class="far" [ngClass]="formPlan.get('estado').value === ESTADO_PENDIENTE ? 'fa-dot-circle' : 'fa-circle'"></i>
            <i class="fas fa-clock"></i> Mantener Pendiente
          </label>
          <input type="radio" class="btn-check" id="estadoConcluido" formControlName="estado" [value]="ESTADO_CONCLUIDO" autocomplete="off">
          <label class="btn depura-estado-opt" for="estadoConcluido">
            <i class="far" [ngClass]="formPlan.get('estado').value === ESTADO_CONCLUIDO ? 'fa-dot-circle' : 'fa-circle'"></i>
            <i class="fas fa-check-circle"></i> Marcar como Concluido
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="esConcluido(s)" class="alert alert-secondary py-2 small mb-3">
      <i class="fas fa-lock me-1"></i> Este registro está Concluido y no admite edición.
    </div>

    <div class="d-flex justify-content-end gap-2 pt-3 border-top">
      <button type="button" class="btn btn-outline-primary px-4" (click)="cerrarPlan()">Cancelar</button>
      <button type="submit" class="btn btn-warning fw-bold px-4" *ngIf="!esConcluido(s)" [disabled]="formPlan.invalid || guardando">
        <i class="fas" [ngClass]="guardando ? 'fa-spinner fa-spin' : 'fa-save'"></i> Guardar y Actualizar
      </button>
    </div>
  </form>
</ng-template>

<!-- MODAL CARGA MASIVA -->
<app-lfsa-modal [innTemplate]="modalCargaTemplate" [classModal]="'modal-dialog modal-lg'" [idButton]="'abrirModalCarga'"
    [idOpen]="'ModalCargaDepura'" [idClose]="'cerrarModalCarga'" [titulo]="titleModalCarga">
</app-lfsa-modal>

<ng-template #modalCargaTemplate>
  <p class="small">Cargue un archivo CSV con las columnas: <b>ID, PLAN_DE_ACCION, ESTADO</b> (ESTADO opcional: Pendiente / Concluido; por defecto Concluido).</p>

  <div class="depura-dropzone mb-3" [class.arrastrando]="arrastrando"
       (click)="fileInput.click()" (dragover)="onDragOver($event)" (dragleave)="arrastrando = false" (drop)="onDrop($event)"
       role="button" tabindex="0" (keydown.enter)="fileInput.click()" aria-label="Seleccionar archivo CSV">
    <i class="fas fa-cloud-upload-alt fa-3x text-primary mb-2"></i>
    <div class="fw-bold">Haga clic aquí o arrastre el archivo CSV</div>
    <div class="small text-muted">
      <span *ngIf="!archivoCsv">Sin archivo seleccionado</span>
      <span *ngIf="archivoCsv"><i class="fas fa-file-csv me-1"></i>{{ archivoCsv.name }}</span>
    </div>
    <input #fileInput type="file" accept=".csv" class="d-none" (change)="onFileSelect($event)" />
  </div>

  <div class="mb-3">
    <label for="textoCsv" class="form-label fw-bold">O pegue el contenido CSV directamente aquí:</label>
    <textarea id="textoCsv" class="form-control font-monospace small" rows="5" [(ngModel)]="textoCsv" [disabled]="!!archivoCsv"
              placeholder="ID,PLAN_DE_ACCION,ESTADO&#10;2,Se contactó al cliente y se regularizó pedido,Concluido"></textarea>
    <div *ngIf="!archivoCsv && textoCsv && validarTextoCsv() as err" class="text-danger small mt-1">{{ err }}</div>
  </div>

  <div *ngIf="resultadoCarga" class="alert small py-2" [ngClass]="resultadoCarga.errores?.length ? 'alert-warning' : 'alert-success'">
    <div><b>Procesados:</b> {{ resultadoCarga.procesados }} | <b>Actualizados:</b> {{ resultadoCarga.actualizados }} | <b>Errores:</b> {{ resultadoCarga.errores?.length || 0 }}</div>
    <ul *ngIf="resultadoCarga.errores?.length" class="mb-0 mt-1 depura-errores">
      <li *ngFor="let e of resultadoCarga.errores">{{ e }}</li>
    </ul>
  </div>

  <div class="d-flex justify-content-end gap-2">
    <button type="button" class="btn btn-outline-secondary" (click)="cerrarCarga()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="procesarCarga()" [disabled]="!cargaValida || procesandoCarga">
      <i class="fas" [ngClass]="procesandoCarga ? 'fa-spinner fa-spin' : 'fa-cogs'"></i> Procesar Carga Masiva
    </button>
  </div>
</ng-template>
